import React, { useState, useEffect }  from 'react'
import plus from '../assets/+.svg'
import NativeSelect from '@mui/material/NativeSelect';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    
  '& .MuiInputBase-input': {
    borderRadius: 5,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #BCD4E4',
    fontSize: 16,
    height: '35px',
    width: '463px',
    color: '#98BCD6',
    paddingLeft: '12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      'Inter',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 5,
    },
  },
}));

function EditForecastForm({category, taskID, entry, setLoading, setRefresh, setOpenPopup, mainBudget, name, value, id, mainID}) {
  const [names, setName] = useState(name);
    const [values, setValue] = useState(value);
    const [budget, setBudget] = useState(mainID);
    useEffect(() => {
      setValue(values.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ','))
     }, [])
     function isFloat(value) {
      // Regular expression to match a floating-point number
      const floatRegex = /^[+-]?\d+(\.\d+)?$/;
    
      return floatRegex.test(value);
    }
  const handleSubmit = (e) => {
    e.preventDefault();
    if(!isFloat(parseFloat(values.replace(/,/g, ''))))
        return;
    console.log(names, values, budget, id)
    if(names.length ===0 || budget == null || budget == '') return;
    fetch('/api-dev/expenses/UpdateBudgetLine/'+id,{
   method: "POST",
       body:JSON.stringify({ BudgetLineName:names, Value:parseFloat(values.replace(/,/g, '')), parentID:budget}),
        headers: {
          'Content-Type': 'application/json',
        },
     }).then(e=>console.log("updated in database") ).catch(e=>console.log(e))
     setRefresh(prev => !prev)
     setOpenPopup(false)
     setLoading(true)
     
}
const handleChangeValue = (e) => {
  /*const inputValue = parseFloat(e.target.value);
  setValue(inputValue);*/
  const rawValue = e.target.value.replace(/,/g, ''); // Remove commas for processing
  const formattedValue = rawValue
.toString()
.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  setValue(formattedValue);
};
const handleChangeName = (e) => {
  setName(e.target.value);
}
  return (
    <>
        <form onSubmit={handleSubmit}>
        <div className='form-input'>
        <label className='form-input-label'>Contract concerned*</label>
            <NativeSelect
          id="demo-customized-select-native"
          input={<BootstrapInput />}
          value={budget}
          onChange={(e)=>setBudget(e.target.value)}
        >
           <option aria-label="None" value={""}/>
            {mainBudget.map((budget,index) => (
                <option key={index} value={budget.MainBudgetLineID}>{budget.MainBudgetLineName}</option>
            ))}
        </NativeSelect>
        </div>
        
            <div className='form-input' style={{marginTop:'30px'}}>
                <label className='form-input-label'>Forecast title*</label>
                <input value={names} onChange={handleChangeName} className='form-input-field' type="text" placeholder="Name" />
            </div>
            <div className='form-input' style={{marginTop:'30px'}}>
                <label className='form-input-label'>Forecast amount*</label>
                <input value={values} onChange={handleChangeValue} id="myNumberInput" className='form-input-field' type="text" placeholder="0,00" />
            </div>
            <div className='form-button' style={{marginTop:'40px'}}>
            <button style={{cursor:'pointer'}} type="submit" className='form-submit'>
                <img src={plus} alt="plus" className='form-submit-icon' />
                &nbsp;
                <span className='form-submit-text'>Edit forecast</span>
            </button>
            </div>
        </form>
            
        </>
  )
}

export default EditForecastForm